import React, { useEffect, useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import MailIcon from "@mui/icons-material/Mail";
import SmsIcon from "@mui/icons-material/Sms";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Header from "../components/Header";
import { API_URL } from "../components/Constant";
import axios from "axios";

const ReferralSection = () => {
  const referralLink = `https://snoword.com/player-signup?referral=${localStorage.getItem("PlayerShareId")}`;

  const shareMessage = `Hey! 😊 I found this fun puzzle called SNOWORD. You should try it out! ❄️ \n\nClick the link to join:\n${referralLink}\n\n`;
  const [linkCopied, setLinkCopied] = useState(false);

  // Handle the share button
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Join SNOWORD puzzle and Earn Points!",
          text: "Check out this awesome puzzle!",
          url: referralLink,
        });
        console.log("Sharing was successful");
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert(
        "Your browser does not support the native share feature. Please use the buttons below to share.",
      );
    }
  };

  // Copy the referral link to clipboard
  const handleCopyLink = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Clipboard API is supported
      navigator.clipboard
        .writeText(referralLink)
        .then(() => {
          setLinkCopied(true);
          setTimeout(() => setLinkCopied(false), 2000); // Reset copied status after 2 seconds
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          fallbackCopyText(referralLink); // Use fallback if Clipboard API fails
        });
    } else {
      // Clipboard API is not supported, use fallback
      fallbackCopyText(referralLink);
    }
  };

  // Fallback method for copying text
  const fallbackCopyText = (text) => {
    // Create a temporary input element
    const tempInput = document.createElement("input");
    tempInput.value = text;
    document.body.appendChild(tempInput);

    // Select the text in the input
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text
    try {
      document.execCommand("copy");
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000); // Reset copied status after 2 seconds
    } catch (err) {
      console.error("Fallback copy failed: ", err);
    }

    // Remove the temporary input
    document.body.removeChild(tempInput);
  };

  // Functions for sharing on specific platforms
  const handleShareOnWhatsApp = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(shareMessage)}`;
    window.open(url, "_blank");
  };

  const handleShareOnFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`;
    window.open(url, "_blank");
  };

  // Share on Twitter
  const handleShareOnTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`;
    window.open(url, "_blank");
  };

  // Share by Email
  const handleShareByEmail = () => {
    const subject = "Invitation to Join SNOWORD Puzzle";
    const body = `Hey! 😊 I found this fun puzzle called SNOWORD. You should try it out! ❄️ \n\nClick the link to join:\n${referralLink}\n\n`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  // Share by SMS
  const handleShareBySMS = () => {
    const body = `Hey! 😊 I found this fun puzzle called SNOWORD. You should try it out! ❄️ \n\nClick the link to join:\n${referralLink}\n\n`;
    window.location.href = `sms:?body=${encodeURIComponent(body)}`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          lineHeight: { md: "42px", xs: "32px" },
          color: "#202f75",
          textAlign: "center",
          fontFamily: "Roboto",
          fontSize: { md: "32px", xs: "24px" },
        }}
      >
        Invite Your Friends and Earn Points!
      </Typography>

      {/* Referral link section */}
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            lineHeight: { md: "42px", xs: "32px" },
            color: "#3D8A75",
            textAlign: "center",
            fontFamily: "Roboto",
            marginTop: "12px",
            fontSize: { md: "22px", xs: "18px" },
          }}
        >
          Shared Link:
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #D3D3D3",
              height: "36px",
              padding: "8px 8px",
              borderRadius: "8px",
            }}
          >
            <Typography
              sx={{
                maxWidth: "100%",
                wordWrap: "break-word",
                fontFamily: "Roboto",
                fontSize: { md: "14px", xs: "12px" },
                fontWeight: 400,
              }}
            >
              {referralLink}
            </Typography>
          </Box>
          <Button
            onClick={handleCopyLink}
            startIcon={
              <ContentCopyIcon sx={{ width: "18px", height: "18px" }} />
            }
            sx={{
              background: "#F18D9E",
              color: "#fff",
              width: "120px",
              border: "1px solid #B14E64",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "12px",
              transition: "background 0.3s, transform 0.3s",
              "&:hover": {
                background: "#D96B8E",
                transform: "scale(1.05)",
              },
              "&:active": {
                background: "#B14E64",
              },
            }}
          >
            {linkCopied ? "Copied!" : "Copy"}
          </Button>

          {/* <Button variant="contained" color="primary" onClick={handleCopyLink} startIcon={<ContentCopyIcon />}>
              {linkCopied ? 'Copied!' : 'Copy'}
            </Button> */}
        </Box>
      </Box>

      {/* Share heading */}
      <Typography
        sx={{
          fontWeight: 500,
          lineHeight: { md: "42px", xs: "32px" },
          color: "#3D8A75",
          textAlign: "center",
          fontFamily: "Roboto",
          marginTop: "20px",
          marginBottom: "12px",
          fontSize: { md: "22px", xs: "18px" },
        }}
      >
        Share with your friends!
      </Typography>

      {/* Share icons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: { md: "8px", xs: "2px" },
        }}
      >
        <Button
          onClick={handleShareOnWhatsApp}
          sx={{ width: "28px", height: "28px" }}
        >
          <WhatsAppIcon sx={{ fontSize: "28px", color: "#25D366" }} />
        </Button>
        <Button
          onClick={handleShareOnFacebook}
          sx={{ width: "28px", height: "28px" }}
        >
          <FacebookIcon sx={{ fontSize: "28px", color: "#3b5998" }} />
        </Button>
        <Button
          onClick={handleShareOnTwitter}
          sx={{ width: "28px", height: "28px" }}
        >
          <TwitterIcon sx={{ fontSize: "28px", color: "#00acee" }} />
        </Button>
        <Button
          onClick={handleShareByEmail}
          sx={{ width: "28px", height: "28px" }}
        >
          <MailIcon sx={{ fontSize: "28px", color: "#D44638" }} />
        </Button>
        <Button
          onClick={handleShareBySMS}
          sx={{ width: "28px", height: "28px" }}
        >
          <SmsIcon sx={{ fontSize: "28px", color: "#34b7f1" }} />
        </Button>
      </Box>
    </Box>
  );
};

export default ReferralSection;
